import { getActionsColumn } from './actions-column';
import { getIdColumn } from './id-column';

export const dataGridColumns = {
  getIdColumn,
  getActionsColumn,
};
